function home() {
  console.log('home')  
}

export default home
